export const DONATION_INFO_TEXT = {
  title: 'Please don\'t go yet!',
  title1: 'Wait! We want to donate on your behalf!',
  description: (name, mindonation, currencyIcon) => `Just ${currencyIcon}${mindonation} can give ${name} a shot at surviving this life-threatening disease and your donation can make this possible`,
};
